import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../../constants/svgIcon';
import { GameActionButton, SvgIcon } from '../../../Molecules';
import {
  GameEndVSResultGroup,
  GameEndVSResultGroupProps,
} from '../../../Organisms';

import './GameEndTemplate.css';

type GameEndTemplateProps = {
  gameEndVSResultGroupProps: GameEndVSResultGroupProps;
  buttonText?: string;
  onClickNext: () => void;
};

const GameEndTemplate = memo(
  ({
    gameEndVSResultGroupProps,
    buttonText = 'Next',
    onClickNext,
  }: GameEndTemplateProps) => {
    const { t } = useTranslation();

    return (
      <div className="game-end-template">
        <GameEndVSResultGroup {...gameEndVSResultGroupProps} />
        <br />
        <div className="next-button-div">
          <GameActionButton
            onClick={onClickNext}
            leading={
              <SvgIcon
                name={SVGIconType.Game}
                width={24}
                height={24}
                stroke="white"
              />
            }
            trailing={
              <SvgIcon
                name={SVGIconType.Play}
                width={24}
                height={24}
                stroke="white"
              />
            }
          >
            <p style={{ padding: '0 1rem' }}>{t(buttonText)}</p>
          </GameActionButton>
        </div>
      </div>
    );
  },
);

export default GameEndTemplate;
